<template>
  <Modal :title="isAdd" :value="value" @on-cancel="close" @on-visible-change="visibleChange" :mask-closable="false" width="1300">
    <Form v-if="isAdd == '添加' || isAdd == '编辑'" :model="form" :label-width="130" ref="formValidate" inline :rules="rules">
      <FormItem label="客户简名：" prop="customerJM">
        <Select v-model="form.customerJM" placeholder="请选择" style="width: 270px">
          <Option value="">---</Option>
          <Option v-for="(item, index) in customerJMList" :value="item.name" :key="index">
            {{ item.name }}
          </Option>
        </Select>
      </FormItem>
	  <FormItem label="到访时间:" prop="visitedTime">
	    <DatePicker type="datetime" placeholder="请选择" style="width: 270px" :editable="false" @on-change="form.visitedTime = $event" :value="form.visitedTime" />
	  </FormItem>
      <FormItem label="被访人：" prop="visitedPerson">
        <Input type="text" placeholder="请输入" v-model="form.visitedPerson" style="width: 270px"></Input>
      </FormItem>
      <FormItem label="走访明细：" prop="interviewDetails">
        <Input type="text" placeholder="请输入" v-model="form.interviewDetails" style="width: 270px"></Input>
      </FormItem>
      <FormItem label="走访人：" prop="visitingPerson">
        <Input type="text" placeholder="请输入" v-model="form.visitingPerson" style="width: 270px"></Input>
      </FormItem>
    </Form>
    <div slot="footer">
      <Button @click="close">取消</Button>
      <Button @click="submit" type="primary">确认</Button>
    </div>
  </Modal>
</template>

<script>
import {
  createCustomerInterviewRecord,
  updateCustomerInterviewRecord,
  getCustomerInterviewRecordById,
} from '../../api/index'
export default {
  data() {
    return {
      loading: false,
      form: {
        customerId: 0,
        customerJM: '',
		visitedTime: null,
        visitedPerson: '',
        interviewDetails: '',
        visitingPerson: '',
        id: '',
      },
      rules: {
        // simpleName: [{ required: true, message: '不能为空', trigger: 'change' }],
        // enterpriseNature: [
        //   { required: true, type: 'number', message: '不能为空', trigger: 'change' },
        // ],
        // province: [{ required: true, type: 'number', message: '不能为空', trigger: 'change' }],
        // zipCode: [{ required: false, message: '不能为空', trigger: 'change' }],
        // legalPerson: [{ required: true, message: '不能为空', trigger: 'change' }],
        // industry: [{ required: false, message: '不能为空', trigger: 'change' }],
        // mainBusiness: [{ required: false, message: '不能为空', trigger: 'change' }],
        // dutyParagraph: [{ required: false, message: '不能为空', trigger: 'change' }],
      },
    }
  },
  props: {
    value: {
      type: Boolean,
    },
    id: {
      type: [String, Number],
    },
    isAdd: {
      type: String,
    },
    customerJMList: {
      type: Array,
    },
  },

  methods: {
    close() {
      this.$emit('close')
      this.clearData()
    },
    visibleChange(value) {
      if (!value) {
        this.$emit('close')
        this.clearData()
      }
    },
    async submit() {
      let _this = this
		this.$refs['formValidate'].validate(async (valid) => {
		  if (valid) {
			if (this.isAdd == '添加') {
			  //添加
			  delete this.form.id
			  delete this.form.guid
			  const data = await createCustomerInterviewRecord(this.form)
			  if (data.data.success) {
				if (data.data.success) {
				  this.$Message.success('添加成功')
				} else {
				  this.$Message.error('添加失败')
				}
			  }
			} else if (this.isAdd == '编辑') {
			  //修改
			  const data = await updateCustomerInterviewRecord(this.form)
			  if (data.data.success) {
				this.$Message.success('修改成功')
			  } else {
				this.$Message.error('修改失败')
			  }
			}
			this.$emit('getTab')
			this.$emit('close')
			this.clearData()
		  }
		})
    },
    clearData() {
        this.form = {
          customerId: 0,
          customerJM: '',
          visitedTime: null,
          visitedPerson: '',
          interviewDetails: '',
          visitingPerson: '',
          id: '',
        }
        this.$refs['formValidate'].resetFields()
    },
    async getById() {
        const data = await getCustomerInterviewRecordById({ id: this.id })
        this.form = { ...data.data.result }
    },
  },
  // watch只会监视isAdd  改变了isAdd的值才执行
  watch: {
    value: {
      handler(newV, oldV) {
        if (this.isAdd == '添加') {
            this.form = {
              customerId: 0,
              customerJM: '',
              visitedTime: null,
              visitedPerson: '',
              interviewDetails: '',
              visitingPerson: '',
              id: '',
            }
            this.$nextTick(() => {
              this.$refs['formValidate'].resetFields()
            })
        } else {
          if (this.id) {
            this.getById()
          }
        }
      },
    },
  },
}
</script>

<style lang="less" scoped>
.fileList {
  display: flex;
  flex-wrap: wrap;
  .filename {
    width: 80px;
    word-break: break-all;
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden; //溢出内容隐藏
    text-overflow: ellipsis; //文本溢出部分用省略号表示
    display: -webkit-box; //特别显示模式
    -webkit-line-clamp: 2; //行数
    line-clamp: 2;
    -webkit-box-orient: vertical; //盒子中内容竖直排列
  }
}
.img {
  margin-right: 10px;
}
.pos {
  position: relative;
}
.pos:hover .img_magnify {
  display: inline-block;
}
.ico {
  position: relative;
  top: 50%;
  left: 50%;
  transform: translate(-100%, -50%);
  cursor: pointer;
}
.img_magnify {
  display: none;
  background: rgba(0, 0, 0, 0.459);
  position: absolute;
  z-index: 1;
  width: 85px;
  height: 85px;
  left: 0px;
  right: 0;
  top: 0;
  bottom: 0;
}
.img_wrap {
  display: flex;
  flex-direction: column;
  padding: 0px 0px;
}
/deep/.ivu-input[type='radio'] {
  width: 20px !important;
}
</style>
